import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { adobeSign } from "../../utils/api";
import "./AdobeSignCallback.css";
import { BIOBANK_ROUTES } from "../../constants/routes";

const AdobeSignCallback = () => {
  const [status, setStatus] = useState("processing");
  const [message, setMessage] = useState(
    "Processing Adobe Sign authentication..."
  );
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Get URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get("code");
        const state = urlParams.get("state");
        const error = urlParams.get("error");
        const errorDescription = urlParams.get("error_description");

        // Handle OAuth error
        if (error) {
          setStatus("error");
          setMessage(
            `Authentication failed: ${
              errorDescription || error
            }. Please try again.`
          );
          setTimeout(() => {
            navigate(BIOBANK_ROUTES.DASHBOARD);
          }, 3000);
          return;
        }

        // Handle missing authorization code
        if (!code) {
          setStatus("error");
          setMessage("No authorization code received. Please try again.");
          setTimeout(() => {
            navigate(BIOBANK_ROUTES.DASHBOARD);
          }, 3000);
          return;
        }

        setMessage("Exchanging authorization code for tokens...");

        // Exchange code for tokens
        const result = await adobeSign.handleCallback(code, state);

        if (result.success) {
          setStatus("success");
          setMessage("Successfully authenticated with Adobe Sign!");

          // Redirect to dashboard after a short delay
          setTimeout(() => {
            navigate(BIOBANK_ROUTES.DASHBOARD);
          }, 2000);
        } else {
          setStatus("error");
          setMessage(`Authentication failed: ${result.error}`);
          setTimeout(() => {
            navigate(BIOBANK_ROUTES.DASHBOARD);
          }, 3000);
        }
      } catch (error) {
        console.error("Adobe Sign callback error:", error);
        setStatus("error");
        setMessage(`An unexpected error occurred: ${error.message}`);
        setTimeout(() => {
          navigate(BIOBANK_ROUTES.DASHBOARD);
        }, 3000);
      }
    };

    handleCallback();
  }, [navigate]);

  const getStatusIcon = () => {
    switch (status) {
      case "processing":
        return "⏳";
      case "success":
        return "✅";
      case "error":
        return "❌";
      default:
        return "⏳";
    }
  };

  const getStatusClass = () => {
    switch (status) {
      case "processing":
        return "processing";
      case "success":
        return "success";
      case "error":
        return "error";
      default:
        return "processing";
    }
  };

  return (
    <div className="adobe-sign-callback">
      <div className="callback-container">
        <div className={`status-card ${getStatusClass()}`}>
          <div className="status-icon">{getStatusIcon()}</div>
          <h2>Adobe Sign Authentication</h2>
          <p className="status-message">{message}</p>

          {status === "processing" && (
            <div className="loading-spinner">
              <div className="spinner"></div>
            </div>
          )}

          {status === "success" && (
            <div className="success-actions">
              <p>Redirecting to dashboard...</p>
            </div>
          )}

          {status === "error" && (
            <div className="error-actions">
              <button
                className="retry-button"
                onClick={() => navigate(BIOBANK_ROUTES.DASHBOARD)}
              >
                Return to Dashboard
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdobeSignCallback;
